export default __webpack_public_path__ + "static/media/brown_map.b8b1deb3.png";